


































































































































































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import CustomMap from '@/components/CustomMap.vue'
import { getNationality } from '@/services/Nationality'
import { getEthnicity } from '@/services/Ethnicity'
import { getReligion } from '@/services/Religion'
import { getStatusUser } from '@/services/StatusUser'
import { getLanguage } from '@/services/Language'

@Component({
  components: { CustomMap },
})
export default class CreateCategiverDialog extends VueExtendedBaseComponent {
  @Prop({ default: '' }) private status!: string
  @Prop() private open!: boolean
  @Prop() private callback!: () => void
  @Prop() private getList!: () => Promise<void>
  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }

  private optionUser = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private valid = false
  private userItem = null
  private address = ''
  private menu = false
  private activePicker = null
  private map = {
    lat: 0,
    lon: 0,
  }
  private loading = false
  private caregiverId = ''
  private graduate = ''
  private nationality = ''
  private ethnicity = ''
  private religion = ''
  private language = []
  private experience = ''
  private charisma = ''
  private centerId = ''
  private statusUser = ''
  private profileImg = ''
  private caregiverLevel = '10'
  private caregiverLevelLists = [
    { text: 'ขั้นพื้นฐาน', value: '10' },
    { text: 'ขั้นสูง', value: '20' },
  ]
  private nationalityList = getNationality().nationality
  private ethnicityList = getEthnicity().ethnicity
  private religionList = getReligion().religion
  private statusUserList = getStatusUser().statusUser
  private languageList = getLanguage().language

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  @Getter('center/centerLists')
  private centerItemLists!: () => void

  get openDialog() {
    return this.open
  }

  @Getter('user/userLists')
  private userItemLists!: () => void

  @Action('center/getCenterList')
  private getCentertList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
  }) => void

  @Action('user/getUserListByRoleId')
  private getUserList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
    id: string,
  }) => void

  // tslint:disable-next-line:adjacent-overload-signatures
  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  public async created() {
    await Promise.all([
      this.getCenterListFunc(),
      this.getUserFunc(),
    ])
  }

  get centerLists() {
    return this.centerItemLists
  }

  get userLists() {
    return this.userItemLists
  }

  private async getCenterListFunc() {
    await this.getCentertList({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify({})).toString('base64'),
      },
    })
  }

  private onInputImage(file) {
    // this.profileImg = file.thumbnail
    this.profileImg = file.file
  }


  private async getUserFunc() {
    await this.getUserList({
      headers: {
        page: this.optionUser.page,
        limit: this.optionUser.itemsPerPage,
        sortBy: _.get(this.optionUser, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.optionUser, 'sortDesc[0]', true),
        search: Buffer.from(this.optionUser.search).toString('base64'),
        filter: Buffer.from(JSON.stringify({})).toString('base64'),
      },
      id: '11175c71fbe64ad49759e94b7f5b3a07',
    })
  }

  get createCaregiverDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'เพิ่ม',
          action: this.createCaregiverAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get invalidateInput() {
    return _.some(
        [],
        (item) => item !== true,
    )
  }

  private requireInput(value) { return value !== '' || 'จำเป็นต้องกรอก' }

  private async changeUser() {
    // console.log(this.userItem)
    this.statusUser =  ''
    this.caregiverId = ''
    this.nationality = ''
    this.ethnicity = ''
    this.religion = ''
    this.language = []
    this.experience = ''
    this.charisma = ''
    this.graduate = ''
    this.centerId = ''
    this.caregiverLevel = '10'
    if (this.userItem != null ) {
      if (typeof this.userItem[`metadata`] !== 'undefined') {
        this.centerId = this.userItem.centerId || ''
        this.profileImg = this.userItem[`metadata`].profile || ''
        this.statusUser = this.userItem[`metadata`].status || ''
        this.caregiverId = this.userItem[`metadata`].caregiverId || ''
        this.nationality = this.userItem[`metadata`].nationality || ''
        this.ethnicity = this.userItem[`metadata`].ethnicity || ''
        this.religion = this.userItem[`metadata`].religion || ''
        this.language = this.userItem[`metadata`].language || []
        this.experience = this.userItem[`metadata`].experience || ''
        this.charisma = this.userItem[`metadata`].charisma || ''
        this.graduate = this.userItem[`metadata`].graduate || ''
        this.caregiverLevel = _.toString(this.userItem[`metadata`].caregiverLevel)
      }
    }
    this.menu = false
  }

  private requireSelect(value) { return [(v) => !!v || 'จำเป็นต้องเลือก'] }

  private async createCaregiverAction() {
    const validate = this.formInstant.validate()
    if (this.requireInput(this.profileImg) !== true) {
      this.updateSnackbar({txt: 'กรุณาอัพโหลดรูปภาพ.', type: 'error'})
      return false
    }
    if (validate) {
      const urlUser = `${process.env.VUE_APP_API_URL}/v1/all/caregiver/` + this.userItem[`_id`]
      const careGiverData = {
        create: {
          roleId: '8de180b16237428082fcca28913aefcd',
          centerId: this.centerId,
          metadata: {
            profile: this.profileImg,
            // caregiverId: this.caregiverId,
            status: this.statusUser,
            graduate: this.graduate,
            nationality: this.nationality,
            ethnicity: this.ethnicity,
            religion: this.religion,
            language: this.language,
            experience: this.experience,
            charisma: this.charisma,
            caregiverLevel: parseInt(this.caregiverLevel, 10),
          },
        },
      }
      this.loading = true
      try {
        await HttpRequestServiceWithToken.put(urlUser, careGiverData.create),
        this.updateSnackbar({txt: 'เพิ่มนักบริบาลสำเร็จ.', type: 'success'})
        await this.callback()
        this.closeDialog()
      } catch (e) {
        this.loading = false
        return false
      }
    } else {
      return false
    }
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
